import { type } from '@/utils/type'

/*
//////////////////////////////////////////////////////////////////
// {{NAME}}
/////////////////////////////////////////////////////////////////
export const ADM_{{NAME}}_SUCCESS =  type('ADM_{{NAME}}_SUCCESS')
export const ADM_{{NAME}}_ERROR =  type('ADM_{{NAME}}_ERROR')

export const ADM_{{NAME}}_DETAIL_SUCCESS =  type('ADM_{{NAME}}_DETAIL_SUCCESS')
export const ADM_{{NAME}}_DETAIL_ERROR =  type('ADM_{{NAME}}_DETAIL_ERROR')

export const ADM_{{NAME}}_SAVE_SUCCESS =  type('ADM_{{NAME}}_SAVE_SUCCESS')
export const ADM_{{NAME}}_SAVE_ERROR =  type('ADM_{{NAME}}_SAVE_ERROR')
*/
export const ROOM_SERVICES_DATAS_SUCCESS =  type('ROOM_SERVICES_DATAS_SUCCESS')
export const ROOM_SERVICES_DATAS_ERROR =  type('ROOM_SERVICES_DATAS_ERROR')

export const ROOM_SERVICES_CRENAUX_SUCCESS =  type('ROOM_SERVICES_CRENAUX_SUCCESS')
export const ROOM_SERVICES_CRENAUX_ERROR =  type('ROOM_SERVICES_CRENAUX_ERROR')